import { Tag } from '../../data/redux/types';
import { ApiResponseTag } from '../iots/tagCodec';

const mapApiTagToTag = (apiTag: ApiResponseTag): Tag => ({
    id: apiTag.id,
    type: apiTag.type,
    name: apiTag.name,
    accountId: apiTag.account_id,
});

export const mapToTagList = (items: ApiResponseTag[]): Tag[] => items.map(mapApiTagToTag);
